import React from 'react';

const DEFAULT_SIZE = 40;

export const ProcessTickIcon = ({ fill = '#E1F4D3', fillSecondary = '#1C452B', width = DEFAULT_SIZE, height = DEFAULT_SIZE, className, style, ...rest }) => {
    const sizeStyle = {
        width,
        height,
        minWidth: width,
        minHeight: height,
        flexShrink: 0,
        ...style,
    };
    return (
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={sizeStyle} {...rest}>
            <g clipPath="url(#clip0_68_71)">
                <path d="M31.7534 9.26169C19.3494 9.26169 9.26074 19.3503 9.26074 31.7544C9.26074 44.1584 19.3494 54.247 31.7534 54.247C44.1575 54.247 54.2461 44.1584 54.2461 31.7544C54.2461 19.3503 44.1575 9.26169 31.7534 9.26169ZM42.6094 26.7332L28.7169 40.6257C28.4589 40.8837 28.1215 41.016 27.7841 41.016C27.4467 41.016 27.1093 40.8837 26.8513 40.6257L20.8974 34.6718C20.3814 34.1558 20.3814 33.3156 20.8974 32.7996C21.4134 32.2836 22.2536 32.2836 22.7696 32.7996L27.7907 37.8208L40.7505 24.861C41.2665 24.345 42.1067 24.345 42.6227 24.861C43.1387 25.377 43.1387 26.2172 42.6227 26.7332H42.6094Z" fill={fill} />
                <path d="M40.744 24.8676L27.7843 37.8274L22.7631 32.8062C22.2471 32.2902 21.4069 32.2902 20.8909 32.8062C20.3749 33.3222 20.3749 34.1624 20.8909 34.6784L26.8449 40.6323C27.1029 40.8903 27.4402 41.0227 27.7776 41.0227C28.115 41.0227 28.4524 40.8903 28.7104 40.6323L42.603 26.7398C43.119 26.2238 43.119 25.3836 42.603 24.8676C42.0869 24.3516 41.2468 24.3516 40.7308 24.8676H40.744Z" fill={fillSecondary} />
                <path d="M31.7551 6.61545C17.8956 6.61545 6.61621 17.8949 6.61621 31.7543C6.61621 45.6138 17.8956 56.8932 31.7551 56.8932C45.6145 56.8932 56.8939 45.6138 56.8939 31.7543C56.8939 17.8949 45.6145 6.61545 31.7551 6.61545ZM31.7551 54.247C19.351 54.247 9.26241 44.1584 9.26241 31.7543C9.26241 19.3503 19.351 9.26164 31.7551 9.26164C44.1591 9.26164 54.2477 19.3503 54.2477 31.7543C54.2477 44.1584 44.1591 54.247 31.7551 54.247Z" fill={fillSecondary} />
            </g>
            <defs>
                <clipPath id="clip0_68_71">
                    <rect width="63.5087" height="63.5087" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};
